import type { VFC } from 'react';
import { Space, Skeleton, Row, Col } from 'antd';
import styled from 'styled-components';
import { RowGutter } from 'common/spacing';

const { Input } = Skeleton;

const StyledSkeletonInput = styled(Input)`
  display: flex;

  .ant-skeleton-input {
    width: 100%;
    min-width: auto;
  }
`;

export const ChartLoadingSkeleton: VFC = () => (
  <Space direction="vertical" size={16} style={{ display: 'flex', marginBottom: '16px' }}>
    <StyledSkeletonInput active block style={{ height: '400px' }} />
    <Row gutter={[RowGutter.Default, RowGutter.Default]} justify="center">
      {['input-1', 'input-2', 'input-3'].map(id => (
        <Col key={`key-${id}`} xl={2} xs={6}>
          <StyledSkeletonInput active size="small" />
        </Col>
      ))}
    </Row>
  </Space>
);
